<template>
  <q-select
    ref="searchState"
    v-model="terms"
    :class="{ required: required }"
    dense
    outlined
    :clearable="clearable"
    use-input
    emit-value
    map-options
    options-dense
    :fill-input="$attrs['fill-input'] !== false"
    hide-selected
    hide-bottom-space
    :disable="disable"
    :options="stateSearchList"
    :label="getLabel"
    :error="error"
    :error-message="errorMessage"
    autocomplete="remove"
    @filter="search"
  >
    <template v-slot:option="scope">
      <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
        <q-item-section>
          <q-item-label v-html="scope.opt.label" />
          <q-item-label caption>{{ scope.opt.sublabel }}</q-item-label>
        </q-item-section>
      </q-item>
    </template>
    <template v-slot:no-option>
      <q-item>
        <q-item-section class="text-grey">
          {{ $t('Common.NoResult.Text') }}
        </q-item-section>
      </q-item>
    </template>
  </q-select>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'StateSearchField',
  props: {
    label: {
      type: String,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
    },
    payload: {
      type: Object,
      default: () => ({}),
    },
    required: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    onSelectReset: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    terms: '',
    stateSearchList: [],
    selected: {},
  }),
  watch: {
    terms: {
      handler(to) {
        this.$emit('input', to)
        let selectedOption = this.getStateListOptions.find(x => x.value === to)
        this.$emit('callback', {
          name: selectedOption.label,
          id: selectedOption.value,
        })
        if (this.onSelectReset) {
          this.reset()
        }
      },
    },
  },
  computed: {
    ...mapGetters(['getStateListOptions']),
    getLabel() {
      return this.label || this.$ts('labels.selectStates')
    },
  },
  methods: {
    ...mapActions(['getStateListAction']),
    search(terms, update, abort) {
      let payload = {
        ...{ search: terms, limit: 10, skipLoading: true },
        ...this.payload,
      }
      this.getStateListAction(payload)
        .then(() => {
          update(() => {
            this.stateSearchList = this.getStateListOptions
          })
        })
        .catch(error => {
          abort()
        })
    },
    getSelected() {
      return this.selected
    },
    reset() {
      this.terms = null
      this.$refs.searchState.reset()
    },
  },
}
</script>
